import { useRef, useState } from 'react'
import { useFormikContext } from 'formik'
import isNil from 'lodash-es/isNil'

import { getRequestProfileBase } from '../../../../../../../api'
import { EMPTY_OBJECT } from '../../../../../../../constants/common'
import { APPOINTMENT_FORM_FIELD_NAME } from '../../../../AppointmentFormModal.constants'
import {
  toAppointmentFormBuildingItem,
  toAppointmentFormFlatItem,
} from '../../../../AppointmentFormModal.utils.anchor'

export function useAppointmentFormRequestAnchor() {
  const { initialValues, setFieldValue } = useFormikContext()

  const [isLoading, setLoading] = useState(false)

  const requestIdRef = useRef(null)

  // The building the form opened with stays, even when the request's read fails
  function fillAnchorFromRequest({ building, flat }) {
    setFieldValue(
      APPOINTMENT_FORM_FIELD_NAME.building,
      initialValues[APPOINTMENT_FORM_FIELD_NAME.building] ??
        toAppointmentFormBuildingItem(building)
    )
    setFieldValue(
      APPOINTMENT_FORM_FIELD_NAME.flat,
      toAppointmentFormFlatItem(flat)
    )
  }

  function handleChangeRequest(option) {
    const requestId = option?.value ?? null

    requestIdRef.current = requestId

    setLoading(!isNil(requestId))

    if (isNil(requestId)) {
      return
    }

    getRequestProfileBase({ id: requestId })
      .then(({ data }) => data)
      .catch(() => EMPTY_OBJECT)
      .then(anchor => {
        if (requestIdRef.current === requestId) {
          fillAnchorFromRequest(anchor)

          setLoading(false)
        }
      })
  }

  return { handleChangeRequest, isLoading }
}
